import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { CadastroReservaMunicipio } from '../models/response/cadastro-reserva-municipio.model';

@Injectable({
  providedIn: 'root',
})
export class CadastroReservaMunicipioService {
  private readonly url: string = `${environment.fullApiUrl}/cadastro-reserva-municipio`;

  private http = inject(HttpClient);

  fetchByMunicipioAndCiclo(
    municipio: string,
    ciclo: number,
  ): Observable<CadastroReservaMunicipio[]> {
    return this.http.get<CadastroReservaMunicipio[]>(
      `${this.url}/municipio/${municipio}/ciclo/${ciclo}`,
    );
  }

  confirmarCadastroReservaMunicipio(
    request: {
      cadastroReservaMunicipioId: number;
      confirmado: boolean;
    }[],
  ): Observable<CadastroReservaMunicipio[]> {
    const req = { confirmacoes: request };
    return this.http.post<CadastroReservaMunicipio[]>(
      `${this.url}/confirmar`,
      req,
    );
  }
}
